// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { createTheme } from '@mui/material';
import broadridgeLogoBlue from '../assets/broadridgeLogoBlue.svg';
import { Branding } from '../utils/branding';
import baseline from './baseline';

const broadridge: Branding = {
  loginLogo: <img height="100px" alt="" src={broadridgeLogoBlue} />,
  headerLogo: <img alt="" src={broadridgeLogoBlue} height="50px" />,
  companyLogo: <img alt="" src={broadridgeLogoBlue} height="50px" />,
};

const broadridgeTheme = createTheme(baseline, {
  components: {
    MuiSvgIcon: {
      defaultProps: {
        color: 'secondary',
      },
    },
  },
  sidebar: {
    active: {
      color: '#FAFAFA',
    },
  },
  headerButtonText: {
    primary: 'red',
  },
  palette: {
    primary: { main: '#00578E' }, // #a6f6ff #00345f #002856 #6575f1
    secondary: { main: '#00a3d6' }, // #002856 #6575f1
    background: {
      default: '#FAFAFA', // #232F40
      paper: '#FAFAFA', // "#364963"
    },
    text: {
      primary: '#000',
    },
  },
});

export default { branding: broadridge, theme: broadridgeTheme };
